module.exports = __webpack_public_path__ + "static/media/search-desktop.161f7f6a.jpg";